import {
    TextField,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
    MenuItem,
  } from "@mui/material";
  import { useState, useEffect } from "react";
  import { useTranslation } from "react-i18next";
  import { LoadingButton } from "@mui/lab";
  import ClearIcon from '@mui/icons-material/Clear';
  import {pick, cloneDeep, add} from "lodash";
  import { ConfirmDialog } from "modules/common";
  import runJoiValidate from "utils/runJoiValidate";
import { USER_EDIT_SCHEMA } from "./UserSchema";
 // Create a validation schema for these fields
  
  export default function UserDialog({
    openUserDialog,
    loading,
    user,
    onCloseDialog,
    onUpdateUser,
    error,
    isSuccess,
  }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [validationErrors, setValidationErrors] = useState(null);
    const [formData, setFormData] = useState({
        id:user.id,
        fullName: `${user?.firstName} ${user?.lastName}`,
        email: user?.email ?? "",
        phone: user?.phone ?? "",
        status: user?.currentStatus ?? "",
    });

    useEffect(() => {
      setFormData({
        id: user.id,
        fullName: `${user?.firstName} ${user?.lastName}`,
        email: user?.email ?? "",
        phone: user?.phone ?? "",
        status: user?.currentStatus ?? "",
      });
    }, [user]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
  
    const handleSubmit = () => {
      setValidationErrors(null);
      let payload =  pick(cloneDeep(formData),["fullName","phone","status"]);
  console.log('submit');
      const errors = runJoiValidate(USER_EDIT_SCHEMA, payload);
      if (errors) {
        console.log("if validation" , errors);
        setValidationErrors(errors);
        return;
      }else{
        console.log("Validation");
       payload = { id: user.id, ...payload };
       console.log(JSON.stringify(payload));
        // Call the update function
        onUpdateUser(payload);
      }
 
    };
  
    return (
      <Dialog
        maxWidth="md"
        dir={theme.direction}
        fullWidth
        fullScreen={fullScreen}
        open={openUserDialog}
        aria-labelledby="user-dialog-title"
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {t('Edit User')}
          <IconButton onClick={onCloseDialog} color="primary">
            <ClearIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={5} alignItems="center">
            {/* Full Name */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                helperText={validationErrors?.firstName ?? ''}
                error={!!validationErrors?.firstName}
                label={t("Full Name")}
                size="small"
                variant="outlined"
                margin="normal"
              />
            </Grid>
  
            {/* Email */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                name="email"
                value={formData.email}
                disabled
                label={t("Email")}
                size="small"
                variant="outlined"
                margin="normal"
              />
            </Grid>
  
            {/* Phone */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                name="phone"
                value={formData.phone.replaceAll(" ", "")}
                onChange={handleChange}
                helperText={validationErrors?.phone ?? ''}
                error={!!validationErrors?.phone}
                label={t("Phone")}
                size="small"
                variant="outlined"
                margin="normal"
              />
            </Grid>
  
            {/* Status */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                name="status"
                select
                value={formData.status}
                onChange={handleChange}
                helperText={validationErrors?.status ?? ''}
                error={!!validationErrors?.status}
                label={t("Status")}
                size="small"
                variant="outlined"
                margin="normal"
              >
                <MenuItem value="ACTIVE">{t("UserStatus.ACTIVE")}</MenuItem>
                <MenuItem value="BLOCKED">{t("UserStatus.BLOCKED")}</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: 'row-reverse'
          }}
        >
          <Box>
            <LoadingButton
              size="small"
              variant="contained"
              disableElevation
              onClick={handleSubmit}
              loading={loading}
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                mr: 5,
              }}
            >
              {t("Edit")}
            </LoadingButton>
          </Box>
          <Box>
            {isSuccess && <Typography color="success.main">{t("Done successfully")}</Typography>}
            {!!error && <Typography color="error">{t(error)}</Typography>}
          </Box>
          <Button
            variant="contained"
            size="small"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
            }}
            onClick={onCloseDialog}
          >
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }